/** @jsxImportSource @emotion/react */

import { vars } from "@imwebme/clay-token";
import { Typography } from "../..";
import { Flex } from "../../utilities/Flex";
import { cardHeaderCSS } from "./CardHeader.css";
import type { CardHeaderProps } from "./CardHeader.types";

export const CardHeader = ({
  align,
  className,
  separator,
  header = "default",
  size = "medium",
  text,
  sx,
  action,
  description,
  as: Element = "div",
  native,
}: CardHeaderProps) => {
  const deprecatedSizeProps = size || (header === "default" ? "medium" : header);

  return (
    <Element
      className={className}
      data-clay-header
      css={[cardHeaderCSS({ align, size: deprecatedSizeProps, separator }), sx]}
      {...native}
    >
      <Flex justifyContent="space-between" flex={align === "center" ? 0 : 1}>
        <Flex.Column gap={vars.spacing[deprecatedSizeProps === "medium" ? 2 : 1]}>
          {text}
          {description && <Typography colorToken="textSub">{description}</Typography>}
        </Flex.Column>

        {action}
      </Flex>
    </Element>
  );
};
